import axios from 'axios'
import Cookies from 'js-cookie'
import store from '@/vuex/index'
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  timeout: 50000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  //此处进行token等数据处理
  config.headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };
  var token = window.sessionStorage.getItem('token');
  config.headers['Authorization'] = `Bearer ${token}`
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
});
service.interceptors.response.use(response => {
  // let status = response.status;
  // if (status === 401) {
  //     debugger
  //     // 说明token过期了,刷新token
  //     return store.dispatch('getInfo', store.getters.token).then(res => {
  //         // 刷新token成功，将最新的token更新到header中，同时保存在localStorage中
  //         // 获取当前失败的请求
  //         const config = response.config
  //         var base = store.getters.url;
  //         var newurl = response.config.url.replace(base, "");
  //         // 重试当前请求并返回promise
  //         return AsyncAxios(newurl, config.config.method, (config.config.method == "get" ? config.config.params : config.config.data), null);
  //     }).catch(res => {
  //         console.error('refreshtoken error =>', res)
  //         //刷新token失败，神仙也救不了了，跳转到首页重新登录吧
  //         window.location.href = '/'
  //     })
  // }
  return response
}, async error => {
  var task = new Promise(async (resolve, reject) => {
    await store.dispatch('getInfo', store.getters.token);
  }).catch(res => {
    //刷新token失败，神仙也救不了了，跳转到首页重新登录吧
    //window.location.href = '/'
  });
  console.log(error);
  return Promise.reject("token过期");

})
// var requestFlag = false;
// // respone拦截器
// service.interceptors.response.use(
//    async response => {

//         if (response.status !== 200) {
//             //此处进行异常处理
//             return Promise.resolve(response.data);
//         }
//         return response
//     },
//     async error => {
//         let status = error.response.status;
//         if (status == 401) {
//             // var base = store.getters.url;
//             // var newurl = error.config.url.replace(base, "");
//             // console.log(error);
//             // console.log("未授权,时间过期");
//             // await store.dispatch('getInfo', store.getters.token)//1 拿到新token后 重新请求过期的请求
//             // console.log(store.getters.token);
//             // error.config.headers.Authorization = `Bearer ${store.getters.token}`
//             // requestFlag = true;
//             //var responses =  await AsyncAxios(newurl, error.config.method, (error.config.method == "get" ? error.config.params : error.config.data), null);//2重新请求
//             // const res = Promise.resolve(responses);
//             // debugger
//             return "dada";
//         }
//         return "dada";
//         //此处进行异常处理
//         //return Promise.reject(error)
//     }
// );

// http response 拦截器
// service.interceptors.response.use(async(response) => {
//     let data = {};
//     if (response && response.data) {
//         let code = Number(response.status || response.data.code);
//         if (code === 401) { // 401 清除token信息并跳转到登录页面
//             const refreshJwt = util.getCookie(`REFRESHJWT-COLLECTOR`);
//             if ((refreshJwt != 'undefined' && refreshJwt) && isLock) {
//                 await refreshToken(response);
//                 isLock = false; //这里防止并发的时候造成死循环,所以要加锁
//                 //刷新完成,继续之前的请求
//                 response.config.headers.Authorization = util.getCookie(`TOKEN-COLLECTOR`);
//                 const result = await axios.request(axiosConf(response.config));
//                 if (result) {
//                     data = result;
//                     isLock = true;
//                 }
//             } else {
//                 Message.error(response.data && response.data.msg || `身份过期，请重新登录!`);
//                 if (router.currentRoute.path != '/login') {
//                     setTimeout(() => {
//                         router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } });
//                     }, 1200);
//                 }
//             }
//         } else if (code === 200) {
//             data = response.data;
//         } else if (code === 403) { //无权限
//             Message.error(`无权访问!`);
//             router.replace({ name: '/403', query: { redirect: router.currentRoute.fullPath } });
//         } else if (code === 410) {
//             Message.error(`身份过期，请重新登录!`);
//             setTimeout(() => {
//                 router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } });
//             }, 1200);
//         } else {
//             Message.error(response.data && response.data.msg || '网络连接出错!请稍后刷新重试!');
//         }
//     }
//     return response;
// }, (error) => {
//     console.log(`object`, error);
//     if (loading) loading.close();
//     Message.error('哎呀~ (ಥ﹏ಥ)网络又开小差了,请稍后刷新重试!');
//     return Promise.reject(error.response.data);
// });


const AsyncAxios = function (url, type, data, that) {

  const getTimestamp = new Date().getTime();
  let base = store.getters.url
  switch (type.toLowerCase()) {
    case "get":

      return service.get(`${base}${url}?timer=${getTimestamp}`, {
        params: data
      }).then(res => res.data)


    case "post":
      return service.post(`${base}${url}`, data).then(res => res.data)
    case "put":
      return service.put(`${base}${url}`, data).then(res => res.data)
    case "delete":
      return service.delete(`${base}${url}`, data).then(res => res.data)

  }

}
const Axios = AsyncAxios
export {
  Axios,
  AsyncAxios,
  AxiosUpload
}



// WEBPACK FOOTER //
// ./src/common/request.js